import script from "./EditArtwork.vue?vue&type=script&setup=true&lang=js"
export * from "./EditArtwork.vue?vue&type=script&setup=true&lang=js"

import "./EditArtwork.vue?vue&type=style&index=0&id=64b21a90&lang=css"

const __exports__ = script;

export default __exports__